import React from 'react';
import LoginForm from '../../components/Authentication/Login';

const LoginPage: React.FC = () => {
  return (
    <>
      <LoginForm />
    </>
  );
};

export default LoginPage;
